<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Família Veículo'"
      :titulo="'família'"
    />

    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Cadastrar Família</span>
          </div>
        </div>
        <form @submit.prevent="onSubmit" id="form">
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="codigo"
                />
                <label>Código</label>
              </div>
            </div>
            <div class="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-9">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="descricao"
                  required
                  autocomplete="off"
                />
                <label>Descrição</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="vendaFutura"
                  required
                >
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
                <label for="valid_status">Venda Futura</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="tipoEmpresa"
                  required
                >
                  <option value="1">Quatro Rodas</option>
                  <option value="2">Duas Rodas</option>
                </select>
                <label for="valid_status">Tipo Empresa</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="status"
                  id="valid_status"
                  required
                >
                  <option value="0">Desabilitado</option>
                  <option value="1">Habilitado</option>
                </select>
                <label for="valid_status">Status</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  v-model="marcaSelecionada"
                  class="form-control txt-form-input"
                  list="datalistMarcas"
                  id="marca"
                  autocomplete="off"
                  @input="updateMarcaSelecionada"
                />
                <label>Marcas</label>
                <datalist id="datalistMarcas">
                  <option
                    v-for="marca in marcas"
                    :data-id="marca.id"
                    :value="marca.descricao"
                    :key="marca.id"
                  ></option>
                </datalist>
              </div>
            </div>
            <!-- Seção: Ações -->
            <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
              <!-- Botões de Ação - Mobile (apenas ícones) -->
              <div class="d-flex d-md-none gap-2">
                <button
                  type="submit"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                >
                  <i class="bi bi-plus-circle" title="Inserir Cliente"></i>
                </button>
              </div>
              <!-- Botões de Ação - Tablet (768px - 991px) -->
              <div class="d-none d-md-flex d-lg-none gap-2">
                <button
                  type="submit"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
              <!-- Botões de Ação - Desktop (≥ 992px) -->
              <div class="d-none d-lg-flex gap-2">
                <button
                  type="submit"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div v-if="abrir_modal">
          <Message :msg="msg" v-show="msg" />
        </div>
      </div>
    </div>

    <!--Bloco do Filtro-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-funnel fs-5 icon-text-form"></i>
            <span class="txt-title-form">Filtro</span>
          </div>
        </div>
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="searchTitle"
              />
              <label>Descrição</label>
            </div>
          </div>
          <div class="col-12 col-sm-5 col-md-5 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="searchVendaFutura"
              >
                <option value="">-----</option>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </select>
              <label>Venda Futura</label>
            </div>
          </div>
          <div class="col-12 col-sm-5 col-md-5 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <select class="form-select txt-form-input" v-model="searchStatus">
                <option value="">------</option>
                <option value="0">Desabilitado</option>
                <option value="1">Habilitado</option>
              </select>
              <label>Status</label>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="pageSize"
                @change="handlePageSizeChange(pageSize)"
              >
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
              <label>Itens Pág.</label>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  retrieveFamilias();
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveFamilias();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveFamilias();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tabelas-->
    <div class="card-container">
      <div class="card card-table-txt">
        <div class="d-md-none">
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in familia_veiculo"
              :key="item.id"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p>
                      <strong>Código:</strong>
                      {{ item.codigo }}
                    </p>
                    <p>
                      <strong>Venda Futura:</strong>
                      {{ getVendaFut(item.vendaFutura) }}
                    </p>
                    <p>
                      <strong>Venda F&I:</strong>
                      {{ getVendaFei(item.venda_fei) }}
                    </p>
                    <p>
                      <strong>Status:</strong>
                      {{ getStatus(item.status) }}
                    </p>
                    <button
                      type="button"
                      class="btn round-btn align-self-end"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_familia(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in familia_veiculo"
              :key="item.id"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p>
                      <strong>Código:</strong>
                      {{ item.codigo }}
                    </p>
                    <p>
                      <strong>Venda Futura:</strong>
                      {{ getVendaFut(item.vendaFutura) }}
                    </p>
                    <p>
                      <strong>Venda F&I:</strong>
                      {{ getVendaFei(item.venda_fei) }}
                    </p>
                    <p>
                      <strong>Status:</strong>
                      {{ getStatus(item.status) }}
                    </p>
                    <button
                      type="button"
                      class="btn btn-modal"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_familia(item)"
                    >
                      <span>Editar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-lg-block">
          <table class="table rf_texto" v-if="!isLoading">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descrição</th>
                <th scope="col">Venda Futura</th>
                <th scope="col">Venda F&I</th>
                <th scope="col">Status</th>
                <th scope="col">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in familia_veiculo"
                :key="item.id"
                class="table-linha"
              >
                <td>{{ item.codigo }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ getVendaFut(item.vendaFutura) }}</td>
                <td>{{ getVendaFei(item.venda_fei) }}</td>
                <td>{{ getStatus(item.status) }}</td>
                <td>
                  <button
                    type="button"
                    class="dropdown-toggle-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_familia(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="loading-indicator">Carregando...</div>
        </div>
        <pagination
          v-if="familia_veiculo.length"
          :total="totalItems"
          :limit="pageSize"
          :offset="currentPage"
          :totalPages="Math.ceil(totalItems / pageSize)"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <!-- Modal para edição -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Editar Família</span>
            <button
              class="btn-close"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_descricao"
                    id="valid_descricao"
                    required
                  />
                  <label for="valid_descricao">Descrição</label>
                  <div class="invalid-feedback">
                    O campo Descrição é obrigatório!
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_codigo"
                  />
                  <label for="valid_descricao">Código</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_vendaFutura"
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Venda Futura</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    list="marcasModal"
                    v-model="selectedOption.descricao"
                    @input="updateSelectedOption"
                    class="form-control txt-form-input"
                    placeholder="Selecione uma marca"
                  />
                  <label>Marcas</label>
                  <datalist id="marcasModal">
                    <option
                      v-for="option in marcas"
                      :key="option.id"
                      :value="option.descricao"
                      :data-id="option.id"
                    >
                      {{ option.descricao }}
                    </option>
                  </datalist>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_status"
                    id="valid_status"
                    required
                  >
                    <option value="0">Desabilitado</option>
                    <option value="1">Habilitado</option>
                  </select>
                  <label for="valid_status">Status</label>
                  <div class="invalid-feedback">
                    Selecione um status, esse campo é obrigatório!
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button type="button" class="btn btn-modal" @click="update()">
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RodapeVue />
  </div>
</template>

<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";

export default {
  name: "Familia",
  components: {
    SidebarVue,
    Navgator,
    Pagination,
    Message,
    RodapeVue
  },
  data() {
    return {
      isLoading: false,
      familia_veiculo: [],
      marcas: [],
      selectedOption: { id: null, descricao: "" },
      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,

      //Campos de cadastro
      codigo: "",
      descricao: "",
      vendaFutura: "",
      status: "",
      marcaId: null,
      marcaSelecionada: "",
      venda_fei: 0,
      tipoEmpresa: "1",

      //Campos modal editar
      edit_id: "",
      edit_codigo: "",
      edit_descricao: "",
      edit_vendaFutura: "",
      edit_status: "",
      edit_venda_fei: 0,

      //Params
      searchTitle: "",
      searchVendaFutura: "",
      searchStatus: "",
      page: 1,
      totalPages: 0,
      totalItems: 0,
      totalPagesMarcas: 0,
      totalItemsMarcas: 0,
      pageSizes: [5, 10, 15, 35, 50, 100],
      pageSize: 5,
      currentPage: 1
    };
  },
  watch: {
    marcaSelecionada() {
      this.updateMarcaSelecionada();
    },
    "selectedOption.descricao"() {
      this.updateSelectedOption();
    }
  },
  mounted() {
    this.retrieveFamilias().then(() => {
      // Só carrega marcas depois que famílias estiverem prontas
      this.retrieveMarcas();
    });
  },
  computed: {
    selectedOptionId() {
      return this.selectedOption.id || null;
    }
  },
  methods: {
    updateMarcaSelecionada() {
      const marca = this.marcas.find(
        (m) => m.descricao === this.marcaSelecionada
      );
      this.marcaId = marca ? marca.id : null;
    },

    clearSelection() {
      this.selectedOption = { id: null, descricao: "" };
    },

    resetForm() {
      this.codigo = "";
      this.descricao = "";
      this.vendaFutura = "";
      this.marcaId = null;
      this.marcaSelecionada = "";
      this.status = "";
      this.venda_fei = 0;
    },

    getStatus(status) {
      return status == 0 ? "Desabilitado" : "Habilitado";
    },

    getVendaFut(vendaFutura) {
      return vendaFutura == 0 ? "Não" : "Sim";
    },

    getVendaFei(venda_fei) {
      return venda_fei == 0 ? "Não" : "Sim";
    },

    async onSubmit() {
      try {
        const token = this.$store.state.auth.user.accessToken;
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": token
        };

        const response = await fetch(`${process.env.VUE_APP_API_URL}familia`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            codigo: this.codigo,
            descricao: this.descricao,
            vendaFutura: this.vendaFutura,
            venda_fei: this.venda_fei,
            marcaId: this.marcaId,
            status: this.status
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Erro ao cadastrar família");
        }

        if (data.StatusOk == 200) {
          this.abrir_modal = true;
          this.msg = data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
          this.resetForm();
          this.retrieveFamilias();
        } else if (data.StatusOk == 204) {
          this.abrir_modal = true;
          this.msg = data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } catch (error) {
        console.error("Erro ao cadastrar família:", error);
        this.abrir_modal = true;
        this.msg = error.message || "Erro ao cadastrar família";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },

    getRequestParams(
      searchTitle,
      page,
      pageSize,
      searchStatus,
      searchVendaFutura
    ) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (searchStatus) {
        params["status"] = searchStatus;
      }
      if (searchVendaFutura) {
        params["vendaFutura"] = searchVendaFutura;
      }
      return params;
    },

    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveFamilias(newPage);
        this.page = newPage;
        this.currentPage = newPage;
      } finally {
        this.isLoading = false;
      }
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.currentPage = 1;
      this.retrieveFamilias();
    },

    async retrieveFamilias(page = this.page) {
      this.isLoading = true;
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          page,
          this.pageSize,
          this.searchStatus,
          this.searchVendaFutura
        );
        const response = await userService.getFamilia(params);
        const { familia_veiculo, totalPages, totalItems } = response.data;
        this.familia_veiculo = familia_veiculo;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
        this.currentPage = page;
        return true;
      } catch (error) {
        console.error("Erro ao buscar famílias:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    getRequestParamsMarca(searchTitle, page, pageSize) {
      let params = {};
      if (searchTitle) params["nome"] = searchTitle;
      if (page) params["page"] = page - 1;
      if (pageSize) params["size"] = pageSize;
      return params;
    },

    async retrieveMarcas() {
      try {
        const params = this.getRequestParamsMarca(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        const response = await userService.getMarca(params);
        const { rows, totalPages, totalItems } = response.data;
        this.marcas = rows;
        this.totalPagesMarcas = totalPages;
        this.totalItemsMarcas = totalItems;
      } catch (error) {
        console.error("Erro ao buscar marcas:", error);
        if (error.response?.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },

    async editar_familia(item) {
      console.log("Dados completos da família:", item);

      this.edit_id = item.id;
      this.edit_codigo = item.codigo;
      this.edit_descricao = item.descricao;
      this.edit_vendaFutura = item.vendaFutura;
      this.edit_venda_fei = item.venda_fei;
      this.edit_status = item.status;

      // Verifica a estrutura real dos dados para encontrar a marca
      if (item.marcaVeiculo) {
        this.selectedOption = {
          id: item.marcaVeiculo.id,
          descricao: item.marcaVeiculo.descricao
        };
      } else if (item.marca) {
        this.selectedOption = {
          id: item.marca.id,
          descricao: item.marca.descricao
        };
      } else if (item.marca_veiculo) {
        this.selectedOption = {
          id: item.marca_veiculo.id,
          descricao: item.marca_veiculo.descricao
        };
      } else {
        // Se não encontrar a marca, limpa o campo
        this.selectedOption = { id: null, descricao: "" };
      }

      console.log("Selected option:", this.selectedOption);
    },

    updateSelectedOption() {
      const selectedMarca = this.marcas.find(
        (option) => option.descricao === this.selectedOption.descricao
      );

      if (selectedMarca) {
        this.selectedOption.id = selectedMarca.id;
      } else {
        // Se não encontrar, limpa o ID mas mantém a descrição digitada
        this.selectedOption.id = null;
      }
    },

    async update() {
      try {
        const token = this.$store.state.auth.user.accessToken;
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": token
        };

        const dados = {
          id: this.edit_id,
          codigo: this.edit_codigo,
          descricao: this.edit_descricao,
          vendaFutura: this.edit_vendaFutura,
          venda_fei: this.edit_venda_fei,
          marcaVeiculoId: this.selectedOption.id,
          status: this.edit_status
        };

        console.log("Dados enviados para atualização:", dados);

        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}familia/${this.edit_id}`,
          dados,
          { headers }
        );

        if (response.data.StatusOk == 200) {
          this.abrir_modal = true;
          this.msg = response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
          this.retrieveFamilias();
          this.clearSelection();
        }
      } catch (error) {
        console.error("Erro ao atualizar família:", error);
        this.abrir_modal = true;
        this.msg = error.response?.data?.message || "Erro ao atualizar família";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    }
  }
};
</script>
